import React, { useState } from "react";

import { useTranslation } from 'react-i18next';

// nodejs library to set properties for components
import PropTypes from "prop-types";

import SweetAlert from "react-bootstrap-sweetalert";

// core components
import { PopUpResult } from "../othelloConstantes.jsx";


export default function OthelloPopUpResult({ ...props }) {

    const { titulo } = props;

    const { t } = useTranslation();

    const [alert, setalert] = useState(props.alert);
    const [evento, setevento] = useState(false);

    const hideAlert = (alertfinal) => {

        setalert(null);
        setevento(true);

        props.onClosePopUpResult('PopUpResult', alertfinal);
    }


    let alertfinal = evento ? alert : props.alert;

    //Limpiamos que el cambio ha sido por el evento, por si en otro lugar se ha realizado el deshacer, o al principio, que en esos casos debe tomar el de por defecto
    //evento = false;

    let tipo = "default";
    let texto = titulo != null ? titulo : "";

    if (alertfinal == PopUpResult.OK)
        tipo = "success";
    else if (alertfinal == PopUpResult.KO)
        tipo = "error";
    else if (alertfinal == PopUpResult.Info)
        tipo = "info";

    if (texto == null || texto == "") {
        if (tipo == "success")
            texto = t("_operarealizada");
        else if (tipo == "error")
            texto = t("_operanorealizada");
        else if (tipo == "info")
            texto = t("_operarealizada");
    }

    let estado = alertfinal == null || alertfinal == "" ? "" :
        (
            <SweetAlert
                type={tipo}
                style={{ display: "block", marginTop: "100px", color: "#000000", fontSize: 9 }}
                title={texto}
                onConfirm={() => hideAlert(alertfinal)}
                /*confirmBtnCssClass={
                    classes != null ? classes.button + " " + classes.error : ""
                }*/
                showConfirm={false}
            >
            </SweetAlert>
        );

    if (alertfinal != null)
        setTimeout(() => hideAlert(alertfinal), 2000);

    return (<div>{estado}</div>);
}

OthelloPopUpResult.propTypes = {
    classes: PropTypes.object.isRequired,
    alert: PropTypes.object,
    titulo: PropTypes.string,
    onClosePopUpResult: PropTypes.object,
    tipo: PropTypes.oneOf([
        'default', 'info', 'success', 'warning', 'danger', 'error', 'input', 'custom'
    ]),
};
